import { Icon, Tooltip } from "@uigovpe/components";
import type { ReactNode } from "react";

type LockedFieldProps = {
  children: ReactNode;
  id: string;
  locked?: boolean;
  showLockIcon?: boolean;
  tooltip: string;
};

export default function LockedField({
  children,
  id,
  locked = true,
  showLockIcon = false,
  tooltip,
}: LockedFieldProps) {
  return (
    <div
      id={id}
      className={
        locked
          ? `relative! cursor-not-allowed! [&_.p-dropdown]:pointer-events-none! [&_.p-dropdown]:cursor-not-allowed! [&_.p-inputtext]:pointer-events-none! [&_.p-inputtext]:cursor-not-allowed! [&_.p-inputtext]:border-zinc-300! [&_.p-inputtext]:text-zinc-500! ${
              showLockIcon ? "[&_.p-inputtext]:pr-10!" : ""
            }`
          : "relative!"
      }
    >
      {children}
      {locked && showLockIcon && (
        <Icon
          icon="lock"
          outline
          className="pointer-events-none! absolute! top-[2.55rem]! right-3! z-10! text-[19px]! text-zinc-500!"
        />
      )}
      {locked && (
        <Tooltip
          target={`#${id}`}
          theme="light"
          position="mouse"
          mouseTrack
          mouseTrackTop={12}
          mouseTrackLeft={12}
          content={<span>{tooltip}</span>}
        />
      )}
    </div>
  );
}

